import { createContext, Dispatch, RefObject, SetStateAction } from "react";
import { ThemeModel } from "../types/ThemeModel";
import { MotionValue } from "motion/react";

export const defaultTheme: ThemeModel = {
  palette: "red",
  background: "neutral-dark",
  foreground: "neutral-light",
};

export const ThemeContext = createContext<{
  theme: ThemeModel;
  setTheme: Dispatch<SetStateAction<ThemeModel>>;
  containerRef: RefObject<HTMLElement>;
  backgroundColor: MotionValue<string>;
}>({
  theme: defaultTheme,
  setTheme: () => {
    throw new Error("ThemeContext not found in tree.");
  },
  containerRef: { current: null },
  backgroundColor: new MotionValue(),
});
